import { RouteRecordRaw } from 'vue-router';

export const routesNames = {
  faq: 'FAQ',
  about: 'About',
}
export const routes: RouteRecordRaw[] = [
  {
    path: 'faq',
    name: routesNames.faq,
    component: () => import('@/pages/FAQ/ui.vue'),
    meta: { title: 'FAQ — Inpocket Ипотека' },
  },
  {
    path: 'about',
    name: routesNames.about,
    component: () => import('@/pages/About/ui.vue'),
    meta: { title: 'О нас — Inpocket Ипотека' },
  },
]